import { motion } from "framer-motion";
import { Radiation } from "lucide-react";
import { TECHNIQUES, IMAGES } from "@/lib/site";

export const Techniques = ({ withImage = true }) => {
  return (
    <section
      data-testid="techniques-section"
      aria-labelledby="techniques-heading"
      className="py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
              Radiation Therapy Techniques
            </div>
            <h2
              id="techniques-heading"
              className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-slate-900"
            >
              Advanced radiation therapy, executed with precision.
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Dr. Anusha is skilled in modern radiation planning across a range
              of platforms — from IMRT and VMAT to CyberKnife, Tomotherapy and
              stereotactic techniques. Every plan is chosen based on tumour
              biology, location and clinical need.
            </p>
            {withImage && (
              <div className="mt-8 rounded-3xl overflow-hidden border border-slate-100 aspect-[4/3]">
                <img
                  src={IMAGES.radiationTech}
                  alt="Advanced radiation therapy technology"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            )}
          </div>

          <div className="lg:col-span-7 space-y-4">
            {TECHNIQUES.map((t, idx) => (
              <motion.article
                key={t.short}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: idx * 0.05 }}
                data-testid={`technique-${idx}`}
                className="group flex gap-5 p-6 rounded-2xl bg-white border border-slate-100 hover:border-blue-200 hover:shadow-[0_16px_30px_-20px_rgba(30,58,138,0.25)] transition-all"
              >
                <div className="shrink-0">
                  <div className="w-14 h-14 rounded-xl bg-blue-50 flex items-center justify-center text-blue-800 font-serif text-sm font-semibold group-hover:bg-blue-900 group-hover:text-white transition-colors">
                    <Radiation className="h-5 w-5" strokeWidth={1.6} />
                  </div>
                  <div className="mt-2 text-[10px] uppercase tracking-[0.18em] text-slate-500 text-center font-semibold">
                    {t.short}
                  </div>
                </div>
                <div>
                  <h3 className="font-serif text-xl text-slate-900">
                    {t.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {t.body}
                  </p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Techniques;
